import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    apiLoading: {
      getRefreshDate: false,
    },
    lastRefreshDate: null,
    riskTypesArray: [],
    riskTypes: [],
    riskTypesMap: {},
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setLastRefreshData(state, action) {
      state.lastRefreshDate = action.payload;
    },
    setRiskTypes(state, action) {
      state.riskTypes = action.payload;
    },
    setRiskTypesMap(state, action) {
      state.riskTypesMap = action.payload;
    },
    setRiskTypesArray(state, action) {
      state.riskTypesArray = action.payload;
    },
  },
});

export const {
  setLoader,
  setLastRefreshData,
  setRiskTypes,
  setRiskTypesMap,
  setRiskTypesArray,
} = globalSlice.actions;

export default globalSlice.reducer;
